if (!customElements.get('pf-certifications')) {
  customElements.define('pf-certifications', class extends HTMLElement {
    connectedCallback() {
      this.life = new AbortController();
      const options = { signal: this.life.signal };
      this.viewport = this.querySelector('.pf-certifications__viewport');
      this.track = this.querySelector('.pf-certifications__track');
      this.items = [...this.track.children];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 767px)');
      this.hovered = false;
      this.visible = false;
      this.focused = false;
      this.dragging = false;
      this.position = 0;
      this.lastWidth = undefined;
      this.viewport.addEventListener('pointerenter', event => { this.hovered = event.pointerType === 'mouse'; }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; }, options);
      this.viewport.addEventListener('focusout', () => { this.focused = this.viewport.contains(document.activeElement); }, options);
      this.viewport.addEventListener('pointerdown', () => { this.dragging = true; }, options);
      const release = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.resumeAt = performance.now() + 1200;
      };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.viewport.addEventListener('wheel', () => { this.resumeAt = performance.now() + 1200; }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        this.focused = true;
        this.viewport.scrollLeft = event.target.offsetLeft - this.items[0].offsetLeft;
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.focused = false; }, options);
      this.motion.addEventListener('change', () => this.resize(), options);
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.viewport);
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
      });
      this.intersection.observe(this);
      this.resize();
      const tick = now => {
        if (this.motion.matches !== this.lastReduced) this.resize();
        const elapsed = Math.min(now - (this.previous || now), 64);
        this.previous = now;
        if (this.loop && this.visible && !document.hidden && !this.motion.matches && !this.hovered && !this.focused && !this.dragging && now >= (this.resumeAt || 0)) {
          if (Math.abs(this.viewport.scrollLeft - this.position) > 2) this.position = this.viewport.scrollLeft;
          this.position = (this.position + this.step * elapsed / (this.seconds * 1000)) % this.loop;
          this.viewport.scrollLeft = this.position;
        } else {
          this.position = this.viewport.scrollLeft;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    resize() {
      const width = this.viewport.clientWidth;
      if (width === this.lastWidth && this.motion.matches === this.lastReduced) return;
      this.lastWidth = width;
      this.lastReduced = this.motion.matches;
      const progress = this.step ? this.viewport.scrollLeft / this.step : 0;
      this.track.querySelectorAll('[data-cert-clone]').forEach(item => item.remove());
      this.step = this.items[0]?.getBoundingClientRect().width || 0;
      this.loop = this.step * this.items.length;
      const moving = this.loop > this.viewport.clientWidth + 1 && !this.motion.matches;
      if (moving) {
        this.items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-cert-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('data-shopify-editor-block');
          this.track.append(clone);
        });
      } else {
        this.loop = 0;
      }
      this.seconds = Number(this.mobile.matches ? this.dataset.mobileSeconds : this.dataset.seconds) || 5;
      this.position = this.loop ? (progress * this.step) % this.loop : progress * this.step;
      this.viewport.scrollLeft = this.position;
    }

    disconnectedCallback() {
      this.life.abort();
      this.resizeObserver.disconnect();
      this.intersection.disconnect();
      cancelAnimationFrame(this.frame);
      this.track.querySelectorAll('[data-cert-clone]').forEach(item => item.remove());
    }
  });
}
